import { cn } from "helpers/classNames";
import { FC, useMemo } from "react";

interface Props {
  color:
    | "cyan"
    | "gray"
    | "yellow"
    | "red"
    | "blue"
    | "indigo"
    | "pink"
    | "green"
    | "rose"
    | "brand"
    | "amber"
    | "stone"
    | "sky"
    | "teal";
  text: string;
  className?: string;
}

export const Tag: FC<Props> = ({ color, text, className }) => {
  const colorClass = useMemo(() => {
    switch (color) {
      case "blue":
        return "bg-blue-50 text-blue-900 ring-blue-600/10";
      case "cyan":
        return "bg-cyan-50 text-cyan-900 ring-cyan-600/10";
      case "gray":
        return "bg-gray-50 text-gray-900 ring-gray-600/10";
      case "indigo":
        return "bg-indigo-50 text-indigo-900 ring-indigo-600/10";
      case "pink":
        return "bg-pink-50 text-pink-900 ring-pink-600/10";
      case "red":
        return "bg-red-50 text-red-900 ring-red-600/10";
      case "yellow":
        return "bg-yellow-50 text-yellow-900 ring-yellow-600/10";
      case "green":
        return "bg-green-50 text-green-900 ring-green-600/10";
      case "rose":
        return "bg-rose-50 text-rose-900 ring-rose-600/10";
      case "brand":
        return "bg-brand-50 text-brand-900 ring-brand-600/10";
      case "amber":
        return "bg-amber-50 text-amber-900 ring-amber-600/10";
      case "stone":
        return "bg-stone-50 text-stone-900 ring-stone-600/10";
      case "sky":
        return "bg-sky-50 text-sky-900 ring-sky-600/10";
      case "teal":
        return "bg-teal-50 text-teal-900 ring-teal-600/10";
      default:
        return "bg-gray-50 text-gray-900 ring-gray-600/10";
    }
  }, [color]);
  return (
    <span
      className={cn(
        "mr-2 inline-flex items-center gap-x-0.5 rounded-md py-1 pl-1.5 pr-2 text-xs font-medium ring-1 ring-inset",
        colorClass,
        className,
      )}
    >
      {text}
    </span>
  );
};
